// import Mathjs from "mathjs"
/**
 * getValue: 是否返回填空数量
 * getMapData: 是否返回变量映射数据
 */
export default function fillSum(str = '|(a-b)/c=d/e=0,a=5~10;b=2;c=a+2;d=#;e=5~10|', getValue = false, getMapData = false) {
  str = str.replaceAll('|', '')
  
  // 取出等式及变量指向
  let [pattern, variable] = str.split(',')
  , empty = 0

  // 拆解变量
  let keyList = variable.split(';'),
  keys = {}
  for(let i = 0; i < keyList.length; i++) {
    let [key, val] = keyList[i].split('=')
    keys[key.trim()] = handleDataType(val)
  }
  
  // 计算表达式变量的最终值
  for(let i in keys) {
    if(keys[i].type == "expression") {
      let vari = keys[i].label.match(/[a-zA-ZⒶ-Ⓩ]/g)
      // console.log(vari)
      vari.filter(its => {
        let variVal = keys[its].value
        keys[i].value = keys[i].value.replaceAll(its, variVal)
      })
      // console.log(keys[i].value)
      keys[i].value = eval(keys[i].value)
    } else if(keys[i].type == "answer") {
      empty++
    }
  }

  // 将(a-b)/c=d/e=0 -> (5 - 5) / 7 = () / 10
  let equation = pattern.match(/[a-zA-ZⒶ-Ⓩ]/g)
  equation.filter(letter => {
    let variVal = keys[letter].value
    pattern = pattern.replaceAll(letter, variVal)
  })
  // console.log(pattern, empty)
  pattern = pattern.replaceAll('/', '÷').replaceAll('*', 'x')

  // 只需要返回变量映射数据
  if(getMapData) {
    return [keys, pattern]
  }
  // console.log(pattern)
  // 需要返回填空数量
  if(getValue) return {pattern, empty}
  else return pattern
}

/**
 * 处理数据类型
 * @param {*} val 
 * @returns {
 *   label: 变量初始值
 *   value: 变量最终值 (根据类型计算)
 *   type: 变量类型 (answer: 答案, random: 随机数, expression: 表达式, number: 定数(数字))
 *   param: 用于<表达式>类型分解数据
 * }
 */
function handleDataType(val) {
  // 答案
  if(val == '#') {
    return {
      label: val,
      value: '()',
      type: 'answer'
    }
  }
  // console.log(val)
  // 随机数
  if(val.match(/~/g)) {
    let [min, max] = val.split('~'),
    value = window.Math.floor(window.Math.random() * (max - min + 1)) + Number(min)
    return {
      label: val,
      value,
      type: 'random',
    }
  }

  // 定数(数字)
  if(!isNaN(Number(val))) {
    return {
      label: val,
      value: Number(val),
      type: 'number'
    }
  }

  // 表达式
  if(val.match(/\s*([a-zA-Z_]\w*|\d+)\s*([\\+\-\\*/]\s*([a-zA-Z_]\w*|\d+)\s*)*$/)) {
    console.log('表达式')
    return {
      label: val,
      value: val, // 不能保证所有变量都已经算出
      type: 'expression',
      parse: parse(val)
    }
  }
}

const stock = []; // 先进后出，每一次出栈，即一对 ()
const parenthesesPairPosition = {}
// 剔除两侧空格
const removeBlank = (expression, l, r) => {
    while (expression[l] === ' ') {
        l++
    }
    while (expression[r] === ' ') {
        r--
    }
    return [l, r]
}
// 剔除两侧小括号
const removeParentheses = (l, r) => {
    if (parenthesesPairPosition[l] === r) return [++l, --r]
    return [l, r]
}
const parse = (expression, l = 0, r = expression.length - 1, skipSearchTimeOrDivide = false) => {
    let isNumber = true;
    let parenthesesDep = 0; // 记录小括号深度
    let firstTimeOrDivideOperator = null; // 记录遇到的第一个 * / 运算符
    let firstTimeOrDivideOperatorIdx = null; // 记录遇到的第一个 * / 运算符的位置
    [l, r] = removeBlank(expression, l, r);
    [l, r] = removeParentheses(l, r);
    for (let i = r; i >= l; i--) {
        const v = expression[i];
        if (v === ')') {
            stock.push(i)
            parenthesesDep++
        } else if (v === '(') {
            const last = stock.pop()
            parenthesesPairPosition[i] = last
            parenthesesDep--
        }
        // skipSearchTimeOrDivide 为 true 表示表达式是连续的 * /
        if (skipSearchTimeOrDivide && firstTimeOrDivideOperator) {
            return {
                type: firstTimeOrDivideOperator,
                left: parse(expression, l, firstTimeOrDivideOperatorIdx - 1, true),
                right: parse(expression, firstTimeOrDivideOperatorIdx + 1, r),
            }
        }
        if (i === l) {
          if (isNumber) {
            let val = expression.slice(l, r + 1).trim(),
            type = val.match(/[a-zA-ZⒶ-Ⓩ]/g)
            return {
              type: type ? 'string' : 'number',
              value: val.match(/[a-zA-ZⒶ-Ⓩ]/g) ? val : Number(val),
            };
          }
          if (parenthesesPairPosition[i] === r) {
              return parse(expression, l + 1, r - 1)
          }
          // * / 拆分，需要遍历到最左侧，所里拆分逻辑写这里
          return {
              type: firstTimeOrDivideOperator,
              left: parse(expression, l, firstTimeOrDivideOperatorIdx - 1, true),
              right: parse(expression, firstTimeOrDivideOperatorIdx + 1, r),
          }
        }
        if (/[0-9]/.test(v) || v === ' ') {
            continue;
        }
        isNumber = false;
        // parenthesesDep === 0 进行表达式分析的时候要确保是同一层级
        if (parenthesesDep === 0 && (v === '+' || v === '-')) {
            return {
                type: v,
                left: parse(expression, l, i - 1),
                right: parse(expression, i + 1, r),
            }
        }
        if (parenthesesDep === 0 && (v === '*' || v === '/') && !firstTimeOrDivideOperator) {
            firstTimeOrDivideOperator = v
            firstTimeOrDivideOperatorIdx = i
        }
    } 
}
// const exec = ast => {
//   const recursion = ast => {
//     if (ast.type === '+') {
//         return recursion(ast.left) + recursion(ast.right)
//     } else if (ast.type === '-') {
//         return recursion(ast.left) - recursion(ast.right)
//     } else if (ast.type === '*') {
//         return recursion(ast.left) * recursion(ast.right)
//     } else if (ast.type === '/') {
//         return recursion(ast.left) / recursion(ast.right)
//     } else if (ast.type === 'number') {
//         return ast.value
//     }
//   }
//   return recursion(ast)
// }
// console.log(parse(expression))
// console.log(eval(expression))
// console.log(exec(parse(expression)))